import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles({
  containerPending: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 4px',
    borderRadius: '100px',
    color: '#EF6C00',
    backgroundColor: `${getRGBA('#EF6C00', 0.08)} !important`,
  },

  containerCompleted: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 4px',
    borderRadius: '100px',
    color: '#2E7D32',
    backgroundColor: `${getRGBA('#2E7D32', 0.08)} !important`,
  },

  status: {
    fontFamily: 'Nunito',
    fontWeight: '600',
    fontSize: '10px',
    lineHeight: '14px',
  },
})

export { useStyles }
